import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'

const TRIGGER =
  'inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg border border-gray-300 bg-stone-100 px-3 py-1.5 text-sm font-medium text-gray-700 transition hover:bg-stone-200 disabled:opacity-60'
const OPTION = 'w-full truncate px-3 py-1.5 text-left text-sm data-focus:bg-gray-50'

type Props = {
  /** Shown when nothing is picked, and as the "clear" row at the top of the list. */
  allLabel: string
  options: { id: string; name: string }[]
  value: string
  labelWidth: string
  onChange: (id: string) => void
}

export default function FilterSelect({ allLabel, options, value, labelWidth, onChange }: Props) {
  return (
    <Menu as="div" className="relative">
      <MenuButton className={TRIGGER}>
        <span className={`${labelWidth} truncate`}>{options.find(({ id }) => id === value)?.name ?? allLabel}</span>
        <ChevronDownIcon className="size-3.5 shrink-0 text-gray-400" />
      </MenuButton>
      <MenuItems
        anchor={{ to: 'bottom start', gap: 4 }}
        className="z-20 w-52 overflow-y-auto [--anchor-max-height:15rem] rounded-lg border border-gray-200 bg-white py-2 shadow-lg focus:outline-none"
      >
        <MenuItem>
          <button
            type="button"
            onClick={() => onChange('')}
            className={`${OPTION} ${value ? 'text-gray-700' : 'font-medium text-indigo-600'}`}
          >
            {allLabel}
          </button>
        </MenuItem>
        {options.map(({ id, name }) => (
          <MenuItem key={id}>
            <button
              type="button"
              onClick={() => onChange(id)}
              className={`${OPTION} ${value === id ? 'font-medium text-indigo-600' : 'text-gray-700'}`}
            >
              {name}
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  )
}
